import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { withPixelLineHeight } from '../../../base/styles/functions.web';
const useStyles = makeStyles()(theme => {
    return {
        badge: {
            // CUSTOM
            // backgroundColor: theme.palette.ui03,
            // color: theme.palette.text01,
            backgroundColor: "var(--theme-primary-color)",
            color: "var(--theme-success-color)",
            textAlign: "center",
            // END
            borderRadius: '100%',
            height: '16px',
            width: '16px',
            // @ts-ignore
            ...withPixelLineHeight(theme.typography.labelBold),
            pointerEvents: 'none',
            position: 'absolute',
            right: '-3px',
            top: '-2px'
        }
    };
});
const ParticipantsCounter = () => {
    const { classes } = useStyles();
    // CUSTOM
    // const participantsCount = useSelector(getParticipantCount);
    // @ts-ignore
    const { knockingParticipants } = useSelector((state) => state["features/lobby"]);
    if (knockingParticipants?.length > 0) {
        return React.createElement("span", { className: classes.badge }, knockingParticipants.length);
    }
    // return <span className = { classes.badge }>{participantsCount}</span>;
    return null;
    // END
};
export default ParticipantsCounter;
